import Reveal from "@/components/base/Reveal";
import { WHATSAPP_URL } from "@/mocks/navigation";
import { useSiteImage, useSiteImageAlt, useSiteText } from "@/lib/siteContent";

export default function Support() {
  const image = useSiteImage(
    "support.image",
    "https://readdy.ai/api/search-image?query=Warm%20realistic%20lifestyle%20photo%20of%20a%20Brazilian%20store%20attendant%20presenting%20different%20womens%20shoes%20on%20an%20elegant%20display%20table%20with%20several%20distinct%20models%2C%20a%20client%20looking%20at%20a%20bordeaux%20sandal%20and%20a%20white%20sneaker%2C%20cozy%20neutral%20boutique%20with%20sand%20interiors%20and%20leather%20textures%2C%20natural%20daylight%2C%20friendly%20genuine%20expressions%2C%20no%20clothing%20rack%2C%20no%20hangers%2C%20no%20text%2C%20no%20logos%2C%20no%20watermark&width=1000&height=800&seq=aur-atendimento-01&orientation=landscape&nocache=true",
  );
  const alt = useSiteImageAlt(
    "support.image",
    "Atendente da Auréa apresentando diferentes modelos de calçados para uma cliente",
  );
  const eyebrow = useSiteText("support.eyebrow", "Atendimento Auréa");
  const title = useSiteText("support.title", "Precisa de ajuda para escolher?");
  const text = useSiteText(
    "support.text",
    "Conte para a gente o que você procura. Ajudamos a encontrar o modelo, a numeração e os acessórios que combinam com o seu momento.",
  );
  const button = useSiteText("support.button", "Falar pelo WhatsApp");

  return (
    <section className="w-full bg-background-50" aria-label="Atendimento próximo">
      <div className="px-4 py-16 md:px-8 md:py-24">
        <div className="mx-auto grid max-w-6xl grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-14">
          <Reveal>
            <div className="relative h-[340px] w-full overflow-hidden rounded-lg bg-background-100 md:h-[460px]">
              <img
                src={image}
                alt={alt}
                title="Atendimento Auréa — calçados femininos e acessórios"
                loading="lazy"
                className="h-full w-full object-cover object-top"
              />
            </div>
          </Reveal>

          <Reveal delay={120}>
            <span className="flex items-center gap-2 text-[11px] uppercase tracking-[0.28em] text-accent-700">
              <span className="flex h-3 w-3 items-center justify-center">
                <i className="ri-heart-3-line text-[11px]" />
              </span>
              {eyebrow}
            </span>
            <h2 className="mt-4 font-heading text-3xl font-medium leading-tight text-foreground-900 md:text-4xl">
              {title}
            </h2>
            <p className="mt-5 text-sm leading-relaxed text-foreground-600 md:text-base">{text}</p>

            <ul className="mt-6 flex flex-col gap-3">
              {[
                "Ajuda para escolher o modelo ideal para a sua rotina",
                "Orientação de numeração brasileira e medidas",
                "Combinação de entrega e retirada do seu jeito",
              ].map((item) => (
                <li key={item} className="flex items-start gap-3 text-sm text-foreground-700">
                  <span className="flex h-5 w-5 shrink-0 items-center justify-center pt-0.5">
                    <i className="ri-check-line text-base text-primary-600" />
                  </span>
                  {item}
                </li>
              ))}
            </ul>

            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-8 inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-whatsapp-line text-lg" />
              {button}
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}